const REAUTHENTICATION_ERRORS = new Set([
  'login_required',
  'consent_required',
  'interaction_required',
  'missing_refresh_token',
  'invalid_grant',
]);

/** Auth0 errors that need interactive sign-in, rather than another silent retry. */
export function requiresReauthentication(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'error' in error &&
    typeof error.error === 'string' &&
    REAUTHENTICATION_ERRORS.has(error.error)
  );
}
